export const URL = process.env.SECURITY_URL;
export const CLIENT = process.env.SECURITY_CLIENT;
export const VERSION = parseInt(process.env.SECURITY_VERSION) || 1;

export const AUTHORIZE = `${URL}/${VERSION === 2 ? 'auth' : 'authorize'}`;
